import { useState } from 'react'

import { PaginationProps } from './Pagination'

type OffsetPagerArgs = {
  /** Page size the page sends as a query param. */
  limit: number
}

type OffsetPagerCallArgs = {
  /** Total item count when the response provides one. */
  total?: number
  /** Item count of the current page; used as a "probably more" heuristic when total is absent (legacy Paging guarantees only count). */
  count?: number
}

type OffsetPagerResult = {
  /** Feed into the query hook's offset param. */
  offset: number
  /** Return to the first page (call when filters or the resource change). */
  reset: () => void
  /** Build Pagination props from the current response's total/count at call time. */
  getPaginationProps: (
    args: OffsetPagerCallArgs,
  ) => Pick<
    PaginationProps,
    'hasPrevious' | 'hasNext' | 'onPrevious' | 'onNext'
  >
}

const useOffsetPager = ({ limit }: OffsetPagerArgs): OffsetPagerResult => {
  const [offset, setOffset] = useState(0)

  return {
    offset,
    reset: () => setOffset(0),
    getPaginationProps: ({ total, count }) => ({
      hasPrevious: offset > 0,
      hasNext: total != null ? offset + limit < total : count === limit,
      onPrevious: () => setOffset((o) => Math.max(0, o - limit)),
      onNext: () => setOffset((o) => o + limit),
    }),
  }
}

export default useOffsetPager
